module.exports = __webpack_public_path__ + "static/john-aucott-0de8cd9ac7d27fd977a106ded50b06b2.png";